import useViewsSelector from "views/stores/useViewsSelector";
const useIsLoading = () => useViewsSelector((state) => state.searchExecution.isLoading);
export default useIsLoading;
